import { SettingsCard } from "@/containers/game/settings/styled-components";
import { StyledSelect } from "@Components/game/common/input/text-field/styled-components";
import ContainerWrapper from "@Components/generic/container-wrapper";
import Section from "@Containers/shared/cards/section";
import TitleWrapper from "@Containers/shared/title-wrapper";
import { Events } from "@Context/common/general/context";
import VRHeaderButtonType from "@Enums/VRHeaderButtonType";
import { useLanguageSettings } from "@hooks/index";
import { CircularProgress, Container, MenuItem, Stack, Typography, useTheme } from "@mui/material";
import { useEffect } from "react";

const SUPPORTED_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
];

const LanguageSettings = () => {
  const theme = useTheme();
  const { currentLocale, isLoading, supportedLanguages, handleLocaleChange, i18n } = useLanguageSettings();

  useEffect(() => {
    Events.app.showHeaderButton.emit({ type: VRHeaderButtonType.BACK, title: i18n("settings.language.title") });
  }, [i18n]);

  return (
    <ContainerWrapper id="SETTINGS-LANGUAGE" sx={{ overflow: "visible" }}>
      <Container maxWidth="sm" sx={{ padding: theme.spacing(0, 0, 6) }}>
        <TitleWrapper title={i18n("settings.language.title")}>
          <Stack spacing={5}>
            <Section title={i18n("settings.language.section")}>
              <Stack spacing={1.5}>
                <SettingsCard>
                  <StyledSelect value={currentLocale} disabled={isLoading} sx={{ width: "100%" }}>
                    {supportedLanguages.map(language => (
                      <MenuItem
                        key={language.value}
                        value={language.value}
                        defaultChecked={currentLocale === language.value}
                        onClick={() => handleLocaleChange(language.value)}
                      >
                        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                          <Typography variant="text1xl500" color="dsBase.v200">
                            {language.label}
                          </Typography>
                          {isLoading && <CircularProgress size={20} />}
                        </Stack>
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </SettingsCard>
              </Stack>
            </Section>
          </Stack>
        </TitleWrapper>
      </Container>
    </ContainerWrapper>
  );
};

export default LanguageSettings;